import { SmartSession } from '@/lib/smartSession';
import axios from 'axios';
import { api, ApiResponse } from './api';
import { Clinic, Practitioner } from './types';
interface VerifyOrganizationAndPractitionerResponse {
  registeredOrganization: boolean;
  registeredPractitioner: boolean;
  organization?: Clinic;
  practitioner?: Practitioner;
}
export const smartService = {
  async getCurrentFHIRUser(session: SmartSession): Promise<any> {
    const response = await axios.get(`${session.fhirServer}/${session.fhirUser}`);
    return response;
  },

  async verifyOrganizationAndPractitioner(
    organizationNPI: string,
    practitionerEmail: string,
    organizationId: string,
    practitionerId: string
  ): Promise<ApiResponse<VerifyOrganizationAndPractitionerResponse>> {
    return api.post<ApiResponse<VerifyOrganizationAndPractitionerResponse>>(
      `/smart-fhir/verify-organization-and-practitioner`,
      {
        organizationNPI,
        practitionerEmail,
        organizationResourceId: organizationId,
        practitionerResourceId: practitionerId,
      }
    );
  },

  async authenticateFHIRUser(
    organizationId: string,
    userId: string
  ): Promise<ApiResponse<{ accessToken: string; idToken: string; refreshToken: string }>> {
    return api.post<ApiResponse<{ accessToken: string; idToken: string; refreshToken: string }>>(
      `/smart-fhir/authenticate-fhir-user`,
      {
        organizationId,
        userId,
      }
    );
  },

  async syncPatients(iss: string, token: string): Promise<ApiResponse<any>> {
    return api.post<ApiResponse<any>>(`/smart-fhir/fetch-patients`, {
      iss,
      token,
    });
  },

  async savePatient(
    patientId: string,
    fhirServer: string,
    accessToken: string
  ): Promise<ApiResponse<any>> {
    return api.post<ApiResponse<any>>(`/smart-fhir/save-patient`, {
      patientId,
      iss: fhirServer,
      token: accessToken,
    });
  },

  async savePrescription(prescriptionId: string, fhirServer: string, accessToken: string): Promise<ApiResponse<any>> {
    return api.post<ApiResponse<any>>(`/smart-fhir/save-medication`, {
      prescriptionId,
      iss: fhirServer,
      token: accessToken,
    });
  },
};
